
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-home-tours",
      function () {
        return require("private-next-pages/virtual-home-tours.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-home-tours"])
      });
    }
  